import React from 'react'
import MMLoadingGif from 'public/img/logos/mm-loading.gif'
import { GeneralMessage } from '@marketing-milk/frontend'

export function Loading() {
  return <GeneralMessage message="" img={MMLoadingGif} imgHeight={125} signature={'Loading...'} />
}
